import { render } from "./ImageExplorer.vue?vue&type=template&id=47b0c584"
import script from "./ImageExplorer.vue?vue&type=script&lang=js"
export * from "./ImageExplorer.vue?vue&type=script&lang=js"
script.render = render

export default script